import { all, fork } from "redux-saga/effects";

import appSagas from "./sagas/app";
import userSagas from "./sagas/user";
import organizationsSagas from "./sagas/organizations";
import propertiesSagas from "./sagas/properties";
import workspacesSagas from "./sagas/workspaces";

export function* rootSaga() {
   yield all([fork(appSagas), fork(userSagas), fork(organizationsSagas), fork(propertiesSagas), fork(workspacesSagas)]);
}
